import { makeObservable, observable, toJS } from 'mobx';
export class AbstractStore {
    constructor(config) {
        this.custom = {};
        this.loading = false;
        this.loaded = false;
        this.config = config;
        makeObservable(this, {
            custom: observable,
            loading: observable,
            loaded: observable,
        });
    }
    setConfig(newConfig) {
        this.config = newConfig;
    }
    toJSON(thing = this) {
        // TODO: make this work better
        return toJS(thing);
    }
}
